import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              吃瓜频道
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              按口味挑选，总有一款瓜适合你
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, idx) => {
            if (idx === 0) {
              return (
                <Link
                  key={cat.slug}
                  to="/category/all"
                  className="lg:col-span-1 group block rounded-xl overflow-hidden bg-background-50 transition-all duration-300 cursor-pointer"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={cat.image}
                      alt={cat.name}
                      title={`吃瓜网官网 - ${cat.name}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5 md:p-6">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                        <i className={`${cat.icon} text-lg`}></i>
                      </span>
                      <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
                        {cat.name}
                      </h3>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                      {cat.description}
                    </p>
                    <span className="text-xs text-primary-500 font-medium">
                      {cat.count} 篇爆料
                    </span>
                  </div>
                </Link>
              );
            }
            return (
              <Link
                key={cat.slug}
                to="/category/all"
                className="group block rounded-xl overflow-hidden bg-background-50 transition-all duration-300 cursor-pointer"
              >
                <div className="p-5 md:p-6 text-center">
                  <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-2">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {cat.description}
                  </p>
                  <span className="text-xs text-accent-500 font-medium">
                    {cat.count} 篇爆料
                  </span>
                </div>
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    title={`吃瓜网官网 - ${cat.name}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}